module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMAoGBAgDAg4MC/UBDwr5Bw0G8ugXdvugAAAGlJREFUGNOF0EsOgCAMRdG2/P9q979XJ4A1YLzDExJeCn/ZSouZzHFBx8diip15AWE5L0UYUA1KgZ+wI7Ko9SW8eUgSVUctcQxoEuMcKArQy1JL2kxi2mxysP4vDuWnVZgl7bUFg57gsxt+xgwjtHDleAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iphone.png
// module id = i1/Y
// module chunks = 21